<svg
  [attr.width]="width"
  [attr.height]="height"
  [attr.fill]="fill"
  [attr.stroke]="stroke"
  [attr.stroke-width]="strokeWidth"
  [attr.stroke-linecap]="strokeLinecap"
  [attr.stroke-linejoin]="strokeLinejoin"
>
  <use [attr.href]="icon"/>
</svg>
